<div class="container">
  <div class="benefits">
    <div class="benefits__txt">
      <h2 [innerHTML]="data.vantages_list_title"></h2>
      <p [innerHTML]="data.vantages_list_description"></p>
    </div>
    <div class="benefits__carousel">
      <ngx-slick-carousel class="carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let item of data.vantages_list; let i = index" class="slide">
          <div class="slide__card">
            <div class="slide__card__img">
              <img [src]="item.image?.url || icons[i % icons.length]" alt="" />
            </div>
            <div class="slide__card__text">
              <p [innerHTML]="item.title"></p>
            </div>
            <div class="slide__card__line"></div>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</div>
